import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { IMAGES } from "../../utils/data";

const DialogComponent = ({
  show,
  title,
  message,
  onClose,
  onConfirm,
  cancelText,
  okText,
  buttonSize,
  footer,
  alertType,
}) => {
  const handleOnCloseClick = (event, reason) => {
    // if (reason === "backdropClick") return;
    if (onClose) onClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleOnCloseClick}
      backdrop="static"
      centered
      className="ps-alert-modal-comp"
    >
      <Modal.Header closeButton={footer === false ? true : false}>
        {title}
      </Modal.Header>
      <Modal.Body>
        {alertType ? (
          <Row>
            <Col md={3} className="text-center">
              {alertType == "success" && (
                <img
                  src={IMAGES.ALERT_SUCCESS?.default}
                  style={{ width: "60px" }}
                />
              )}
              {alertType == "error" && (
                <img
                  src={IMAGES.ALERT_ERROR?.default}
                  style={{ width: "60px" }}
                />
              )}
            </Col>
            <Col md={9} className="d-flex  align-items-center">
              {message}
            </Col>
          </Row>
        ) : (
          <Row>
            <Col md={12} className="d-flex  align-items-center">
              {message}
            </Col>
          </Row>
        )}
      </Modal.Body>
      {footer !== false && (
        <Modal.Footer>
          <Button
            onClick={onClose}
            variant={onConfirm ? "outline-primary" : "primary"}
            size={buttonSize || "sm"}
          >
            {cancelText ? (
              cancelText
            ) : onConfirm ? (
              <>
                <i className="ti-close me-2"></i>Cancel
              </>
            ) : (
              <span className="px-2">Ok</span>
            )}
          </Button>
          {onConfirm && (
            <Button
              className="ms-2"
              onClick={() => {
                onConfirm && onConfirm();
                onClose();
              }}
              size={buttonSize || "sm"}
              autoFocus
            >
              <i className="fa-solid fa-check me-2"></i>
              {okText || "Confirm"}
            </Button>
          )}
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default DialogComponent;
